import React from 'react';
import { Button } from 'antd';
import html2canvas from 'html2canvas';

const DownloadTab: React.FC = () => {
  const exportToImage = async (
    element: any,
    fileName: string = "screenshot.png"
  ): Promise<void> => {
    try {
      // 核心配置（根据需求调整）
      const overlayElement = document.querySelector('.DashboardSetting') as HTMLElement;
      const imageInfo = document.querySelector('.photo') as HTMLElement;
      if (overlayElement) {
        overlayElement.style.display = 'none';
      }
      if (imageInfo) {
        imageInfo.style.display = 'none';
      }
      const canvas = await html2canvas(element, {
        scale: window.devicePixelRatio * 2, // 提升清晰度 [1,2](@ref)
        useCORS: true,                     // 允许跨域图片加载 [1,2](@ref)
        backgroundColor: "#ffffff",         // 白色背景（避免透明背景异常）[1](@ref)
        logging: false,                     // 禁用控制台日志 [1](@ref)
        allowTaint: true,                   // 兼容不支持 CORS 的资源 [4](@ref)
        height: element.scrollHeight - 1,
      });

      // 生成图片 DataURL
      const imageData = canvas.toDataURL("image/png", 1.0);
      overlayElement.style.display = 'block';
      if (imageInfo) {
        imageInfo.style.display = 'block';
      }

      // 创建下载链接
      const link = document.createElement("a");
      link.href = imageData;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("导出图片失败:", error);
      throw new Error("导出过程中发生错误");
    }
  };

  const download = () => {
    const element = document.querySelector(".Dashboard");
    if (element) {
      exportToImage(element);
    }
  };

  return (
    <Button type="primary" onClick={download}>
      下载
    </Button>
  );
};

export default DownloadTab;
